import styled from 'styled-components'

interface ContainerProps {
    shouldShow: boolean
}

export const Container = styled.div<ContainerProps>`
    ${({ shouldShow }) => !shouldShow && `display: none`};
`
